export class TblStateQuickSetVersionInfo {
  id?: number;
  empId?: number;
  quickSetVersion?: number;
  stateVersion?: number;
  quickSetLastUpdatedTime?: string;
  stateLastUpdatedTime?: string;
  quickSetLastUpdatedDate?: string;
  stateLastUpdatedDate?: string;
  isStateModified?: boolean;
  isQuickSetModified?: boolean;
  fileid?: string;
}
